import * as React from "react"

const Sale = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="m1.575 8.06-.353.354.353.354 5.657 5.657.354.353.353-.353 6.364-6.364.177-.177-.035-.248-.707-4.95-.053-.37-.372-.054-4.95-.707-.247-.035-.177.177L1.575 8.06Zm6.01 5.304-4.949-4.95L8.47 2.581l4.33.618.62 4.331-5.834 5.834Zm3.536-7.071a1 1 0 1 0-1.414-1.414 1 1 0 0 0 1.414 1.414Z" />
  </svg>
)

export default Sale
